import { EventEmitter, Output } from '@angular/core';
import { Component, Input, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DocumentsRepositoryService } from 'src/app/services/documents-repository.service';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { FileDetails, SupplierDetails } from 'src/app/shared/models/documents.model';
import { Role, User } from 'src/app/shared/models/user.model';
import { DownloadEditComponent } from '../download-edit/download-edit.component';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CwsSupplierNameComponent } from '../../solar-forms/cws-supplier-name/cws-supplier-name.component';
import { CustomCommonIconComponent } from '../../shared/custom-icon/custom-common-icon/custom-common-icon.component';
import { NewsUpdateTableTooltipcelheaderIsexpriedComponent } from 'src/app/admin/news-updates-management/news-update-table-tooltipcelheader-isexpried/news-update-table-tooltipcelheader-isexpried.component';

@Component({
  selector: 'app-document-search-grid',
  templateUrl: './document-search-grid.component.html',
  styleUrls: ['./document-search-grid.component.scss']
})

export class DocumentSearchGridComponent implements OnInit, OnChanges {
  @Input() supplierDetails: SupplierDetails;
  @Input() IsColumnsToFit: boolean;
  @Input() refreshDocumentSearchGrid: string;
  @Output() editFormHandler: EventEmitter<string> = new EventEmitter<string>();
  private unsubscribe: Subject<void> = new Subject<void>();
  paginationPageSize: number;
  cacheBlockSize: number;
  documentDays: number = 14;
  gridApi: any;
  gridColumnApi: any;
  rowData: any[];
  fileDetails!: FileDetails[];
  roleOptions: Role[];
  filterBy: [];
  defaultColDef: {};
  roleApi;
  editDownloadIcon: any;
  gridOptions: GridOptions;
  documentSupplierName: string;
  todaysDate: string
  CombinedPastAndCurrentDate: string;
  formattedPastTwoWeeksDate: string;
  combinedDate: string;
  tooltipOptions: Object;
  globalDocumentValue: boolean = false;
  tomorrow = new Date();
  range = new UntypedFormGroup({
    startDate: new UntypedFormControl(),
    endDate: new UntypedFormControl(),
  });
  currentDate: Date;
  pastTwoWeeksDate: Date;
  showfilterBy: boolean = false;
  columnDefs = [
    { field: 'supplier', sortable: true, resizable: true, filter: true, width: 300, cellStyle: { 'white-space': 'normal', 'width': '300px !important' }, unSortIcon: true, autoHeight: true, suppressMovable: true, cellRenderer: 'supplierNamecell', },
    { field: 'documentName', sortable: true, resizable: true, filter: true, width: 350, cellStyle: { 'white-space': 'normal', 'width': '350px !important' }, cellRenderer: 'editDownloadCell', unSortIcon: true, autoHeight: true, suppressMovable: true,
    headerComponentFramework:NewsUpdateTableTooltipcelheaderIsexpriedComponent  },
    { field: 'documentType', sortable: true, resizable: true, filter: true, width: 123, unSortIcon: true, autoHeight: true, cellClass:'sg-search' },
    { field: 'solarPartNumber', sortable: true, resizable: true, filter: true, width: 124, unSortIcon: true, autoHeight: true, cellClass:'sg-search' },
    { field: 'serialNumber', sortable: true, resizable: true, filter: true, width: 124, unSortIcon: true, autoHeight: true, cellClass:'sg-search' },
    { field: 'purchaseOrder', sortable: true, resizable: true, filter: true, width: 123, unSortIcon: true, autoHeight: true, cellClass:'sg-search'  },
    {
      field: 'uploadedOn', sortable: true, sortingOrder: ["desc", "asc"], sort: "desc",
       resizable: true, width: 123,
      filter: 'agDateColumnFilter', unSortIcon: true, autoHeight: true, 
      comparator: this.dateComparator,
      filterParams: {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
           const dateAsString =  moment(cellValue).format('MM/DD/YYYY');
          if (dateAsString == null) {
            return 0;
          }
          const dateParts = dateAsString.split('/');
          const day = Number(dateParts[1]);
          const month = Number(dateParts[0]) - 1;
          const year = Number(dateParts[2]);
          const cellDate = new Date(year, month, day);
          if (cellDate < filterLocalDateAtMidnight) {
            return -1;
          } else if (cellDate > filterLocalDateAtMidnight) {
            return 1;
          }
          return 0;
        },
        browserDatePicker: true,
      }
    },
    { field: 'UploadedBy', sortable: true, resizable: true, filter: true,  unSortIcon: true, autoHeight: true, cellClass: 'sg-search' },
    { field: 'tag', resizable: true, filter: true, width: 300, cellStyle: { 'white-space': 'normal', 'width': '300px !important' }, cellRenderer: 'tagCell', unSortIcon: true, autoHeight: true, suppressMovable: true, },
  ];
  supplierFilter: any;

  constructor(private documentsService: DocumentsRepositoryService,
    private userRepositoryService: UserRepositoryService,) {
    this.paginationPageSize = 10;
    this.cacheBlockSize = 20;
    this.editDownloadIcon = {
      editDownloadCell: DownloadEditComponent,
      supplierNamecell: CwsSupplierNameComponent,
      tagCell: CustomCommonIconComponent
    };
    this.gridOptions = {
      defaultColDef: {
        flex: 1,
        minWidth: 90,
        resizable: true,
        filter: true,
        floatingFilter: true
      },
      context: {
        DocumentSearchGridComponent: this
      },
    }
  }
  dateComparator(date1: string, date2: string): number {
    return new Date(date1) < new Date(date2) ? -1 : 1;
  }

  compareDocumentSelectedDates() {
    if (this.range.value.startDate && this.range.value.endDate ) {
      this.pastTwoWeeksDate = this.range.value.startDate;
      this.range.value.endDate ? this.range.value.endDate : this.currentDate;
      this.currentDate = this.range.value.endDate
        ? this.range.value.endDate
        : this.currentDate;
      this.getGenericDocumentDetails(true);
      this.updateFilterChange()
    }
  }

  getGenericDocumentDetails(rangeDate: boolean) {
    this.documentsService.documentSearch(this.pastTwoWeeksDate, this.currentDate, this.roleApi.roleName, this.roleApi.supplierId)
      .pipe(takeUntil(this.unsubscribe)).
      subscribe((response) => {
        if (rangeDate) {
          this.rowData = this.bindGridData(response);
          if(Object.keys(this.filterBy).length > 0) {
            setTimeout(() => {
              const fi = this.gridApi.getFilterInstance('supplier');
              fi.setModel({
                type: 'contains',
                filter: this.documentSupplierName
              });
              this.gridApi.onFilterChanged();
            }, 400);
          }
          
        } else {
          this.gridApi.setColumnDefs(this.columnDefs);
          this.rowData = this.bindGridData(response);
        }
      });
  }

  getNumberOfDays(start, end) {
    const date1 = new Date(start);
    const date2 = new Date(end);
    const oneDay = 1000 * 60 * 60 * 24;
    const diffInTime = date2.getTime() - date1.getTime();
    const diffInDays = Math.round(diffInTime / oneDay);
    return diffInDays;
  }

  // uploadedFilterValue() {
  //   if (this.combinedDate) {
  //     let selectedDateVal: any = document.getElementsByClassName('ag-text-field-input')[6];
  //     selectedDateVal.value = this.combinedDate;
  //   }
  // }

  ngOnInit(): void {
    this.getUserRoleData();
    this.columnDefs;
    this.currentDate = new Date();
    this.todaysDate = moment(this.currentDate).format('MM/DD/YYYY');
    this.pastTwoWeeksDate = new Date(+new Date - 12096e5);
    this.formattedPastTwoWeeksDate = moment(this.pastTwoWeeksDate).format('MM/DD/YYYY');
    this.CombinedPastAndCurrentDate = this.formattedPastTwoWeeksDate + ' - ' + this.todaysDate;
    this.compareDocumentSelectedDates();
    this.range.controls.startDate.setValue(this.pastTwoWeeksDate)
    this.range.controls.endDate.setValue(new Date());
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.refreshDocumentSearchGrid) {
      if (changes.refreshDocumentSearchGrid.currentValue == 'refresh document search grid' && this.roleApi) {
        this.getGenericDocumentDetails(true);
      }
    }
  }

  populateGridData(params: GridOptions): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.globalDocumentValue = true;
    this.getGenericDocumentDetails(false);
  };

  getUserRoleData() {
    this.userRepositoryService.loggedUserData$.pipe(
      takeUntil(this.unsubscribe)).subscribe((user: User) => {
        this.roleApi = user;
      });
  }

  private bindGridData(
    fileDetails: any
  ): FileDetails[] {
    let userAccessData = fileDetails.filter(item => this.documentsService.folderPermission(item.filePath.split('\\')[1], this.roleApi))
    return userAccessData.map((userAccessData) => ({
      supplier: userAccessData.filePath.split('\\')[0],
      documentName: userAccessData.documentName,
      documentType: userAccessData.uiDocumentAttributesDTO.documentAttributes.documentType,
      solarPartNumber: userAccessData.uiDocumentAttributesDTO.documentAttributes.additionalInformation.solarPartNumber,
      serialNumber: userAccessData.uiDocumentAttributesDTO.documentAttributes.additionalInformation.serialNumbers,
      purchaseOrder: userAccessData.uiDocumentAttributesDTO.documentAttributes.additionalInformation.purchaseOrderNumbers,
      createdBy: userAccessData.createdBy,
      supplierId: userAccessData.supplierId,
      UploadedBy: userAccessData.lastModifiedBy,
      id: userAccessData.fileId,
      uploadedOn: moment(userAccessData.createdUtc).format('DD MMM YYYY'),
      hasPermission: this.checkPermissionAccess(userAccessData),
      tag: userAccessData.uiDocumentAttributesDTO.documentAttributes.additionalInformation.tags
    }));
  };

  clearFilter(params) {
    this.documentSupplierName = '';
    this.gridApi.setFilterModel(null);
    this.gridApi.setRowData(this.rowData);
  }

  private checkPermissionAccess(fileDetails): boolean {
    let foldarName: string = fileDetails.filePath.split('\\')[1].toString();
    return this.documentsService.folderPermission(foldarName, this.roleApi, true);
  }

  editDocHandler(id: string) {
    this.editFormHandler.emit(id)
  };

  onFirstDataRendered() {
    const supplierFilterCtrl = this.gridApi.getFilterInstance('supplier');
    this.documentSupplierName = this.supplierDetails ? this.supplierDetails.supplierName : ''
    supplierFilterCtrl.setModel({
      type: 'contains',
      filter: this.documentSupplierName
    });
    this.updateFilterChange()
  }

  onFilterChanged(event: any): void {
    this.filterBy = this.gridApi.getFilterModel();
    if(Object.keys(this.filterBy).length > 0) {
    this.showfilterBy = true;
    // const floatingFilterInput = document.querySelector('.ag-floating-filter-input');
    //   if(floatingFilterInput) {
    //     if(this.documentSupplierName) {
    //       this.supplierFilter = this.gridApi.getFilterInstance('supplier');
    //     }
    //     floatingFilterInput.addEventListener('keydown', this.filterInstance);
    //   }
    } 
  }

  // filterInstance(event?: KeyboardEvent) {
  //      if(event.key === 'Backspace' || event.key === 'Delete') {
  //        event.stopPropagation();
  //      }
  // }

  private updateFilterChange(): void {
    const dateFilterCtrl = this.gridApi.getFilterInstance('uploadedOn');
    dateFilterCtrl.setModel({
      type: 'inRange',
      dateFrom: moment(this.range.value.startDate).format('MM/DD/YYYY'),
      dateTo: moment(this.range.value.endDate).format('MM/DD/YYYY'),
    });
    this.gridApi.onFilterChanged();
  }
}
